import Loading from "../../utils/Loading"; //获取加载组件
import { ElMessage, ElMessageBox } from "element-plus";

import Api_Universal from "../../api/FrontEnd/Universal";

export default {
	name: 'ComponentsTop',
	components: {

	},
	props:{

	},
	data(){
		return{
			LogoData:"",
			NavData:[],

			SearchKey:"",
		}
	},
	methods:{
		GetTopElement(){
			let RequestData = {

			};
			let ReturnData = Api_Universal.GetTopElement(RequestData);
			ReturnData.then(response => {
				//console.log(response);
				let State = response['Data'][0].State;
				let Message = response['Data'][0].Message;
				if(State == 'Success'){
					let Data = JSON.parse(response['Data'][0].Data);
					// console.log(Data);
					this.LogoData = Data.LogoData[0].Image.Url;
					this.NavData = Data.NavData;
					
				}else{
					ElMessage.error(Message);
				}
			})
		},

		IsSelectNav(Path){
			let Status = false;
			let NowPath = this.$route.path;

			// console.log(NowPath);

			if(NowPath == Path){
				Status = true;
			}else{
				if(Path == '/News'){ //判断是否为西乳动态
					if(
						NowPath.includes("/XijiangNewsList") ||
						NowPath.includes("/XijiangBulletinList") ||
						NowPath.includes("/XijiangPoliciesRegulationsList") ||
						NowPath.includes("/XijiangPartyBuildingCultureList") ||
						NowPath.includes("/News") ||
						NowPath.includes("/Preview")
					){
						Status = true;
					}else{
						Status = false;
					}
				}else if(Path == '/Product'){ //判断是否为产品中心
					if(NowPath.includes("/Product")){
						Status = true;
					}else{
						Status = false;
					}
				}else if(Path == '/'){
					if(NowPath.includes("/Index")){
						Status = true;
					}else{
						Status = false;
					}
				}else{
					Status = false;
				}
			}

			return Status;
		},

		NavClick(Data){
			this.$router.push(Data.Path);
			this.SearchKey = "";

			this.$emit("onScrollTop");
		},

		onToHome(){
			this.$router.push("/");
		},

		onSearchClick(){
			// if(!this.SearchKey){
			// 	ElMessage.error("请输入关键词搜索");
			// 	return false;
			// }

			this.$router.push({
				path:"/Search",
				query:{
					SearchKey:this.SearchKey
				}
			})

			this.$emit("onSearch",this.SearchKey);
		},

		onSearchKeyKeydown(e){
			if(e.keyCode == 13){
				this.onSearchClick();
			}
		},

		onSearchKeyClear(){
			this.onSearchClick();
		}
	},
	mounted(){
		this.GetTopElement();

	
	},
	watch: {

		
	},
	emits:{
		"onScrollTop":null,
		"onSearch":null,
	}
}

